import React from "react";
import { BookOpenIcon, LayersIcon, GiftIcon, DownloadIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/offer";
const trust = [{
  icon: BookOpenIcon,
  label: "189 páginas"
}, {
  icon: LayersIcon,
  label: "13 módulos"
}, {
  icon: GiftIcon,
  label: "8 bonos + kit"
}];
export function Hero() {
  return <header className="hero-bg relative overflow-hidden bg-cream bg-cover bg-center" data-id="element-132" data-mp="4jm7tt5w3bt7">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 pb-16 pt-10 md:px-8 md:pb-24 md:pt-16 lg:grid-cols-[1.1fr_1fr] lg:gap-16" style={{
      backgroundColor: "#FBF7EE",
      backgroundImage: "none"
    }} data-id="element-133" data-mp="127ecf87a1fat">
        <div data-id="element-134" data-mp="sd48ct8z2sk9">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-mint px-3 py-1.5 text-xs font-bold text-ink sm:text-sm" data-id="element-135" data-mp="ncgk2fc4optq">
            <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-136" data-mp="3d2bjjokooxv0" />
            Guía digital + 8 bonos
          </p>
          <h1 className="font-display text-[2.35rem] font-semibold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-[3.6rem]" data-id="element-137" data-mp="380w020y5mzeq">
            Empezá tu propio negocio de limpieza{" "}
            <span className="whitespace-nowrap bg-sun px-1.5" data-id="element-138" data-mp="3o6amdlpjdov7">desde cero.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink md:text-xl" data-id="element-139" data-mp="399jojgvigl7p">
            <strong className="font-bold" data-id="element-140" data-mp="3e8efx77jni3f">De cero a tu empresa de limpieza</strong> es una guía práctica para
            organizar tus servicios, calcular cuánto cobrar y conseguir tus primeros clientes.
          </p>
          <p className="mt-4 max-w-xl leading-relaxed text-muted" data-id="element-141" data-mp="359j6lm97drvw">
            Sin experiencia previa, sin empezar con un equipo de empleados y sin gastar una fortuna en el intento.
          </p>

          <div className="mt-9 flex flex-col items-stretch gap-4 sm:items-start" data-id="element-142" data-mp="2vjpzaxg3fyxg">
            <CtaButton data-id="element-143" data-mp="2hk84o1g49rg6">Quiero empezar hoy</CtaButton>
            <p className="flex items-center justify-center gap-2 text-sm text-muted sm:justify-start" data-id="element-144" data-mp="2hlj9m4lat58v">
              <DownloadIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-145" data-mp="2lmld4xm903gn" />
              Compra única · Acceso digital en PDF
            </p>
          </div>

          <ul className="mt-10 grid grid-cols-3 gap-3 border-t border-line pt-6 sm:flex sm:flex-wrap sm:gap-x-6" data-id="element-146" data-mp="n9qhz7v3iq6w">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex flex-col items-center gap-2 text-center text-xs font-semibold text-ink sm:flex-row sm:text-left sm:text-sm" data-id="element-147" data-mp="ddwyt5mvfyg5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-mint" data-id="element-148" data-mp="1ayjiziqkro8d">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-149" data-mp="112pvx5f8cccc" />
                </span>
                {label}
              </li>)}
          </ul>
        </div>

        <div className="relative mx-auto w-full max-w-[20rem] sm:max-w-md" data-id="element-150" data-mp="x0cu2s3lsyku">
          <img src={images.heroMockup} width={512} height={512} loading="eager" decoding="sync" {...{
          fetchpriority: "high"
        }} alt="Logo De cero a tu empresa de limpieza con productos y elementos de limpieza" className="w-full rounded-full shadow-[0_24px_60px_-20px_rgba(18,40,60,0.35)]" style={{
          borderTopWidth: "1px",
          borderRightWidth: "1px",
          borderBottomWidth: "1px",
          borderLeftWidth: "1px"
        }} data-id="element-151" data-mp="3lt74sotvtnt7" />
          <div className="absolute -bottom-2 left-0 rounded-2xl bg-white px-4 py-3 shadow-lg ring-1 ring-line sm:bottom-6 sm:-left-6" data-id="element-152" data-mp="268g3e64amso7">
            <p className="text-xs font-semibold text-muted" data-id="element-153" data-mp="2fzsugvi9pet6">Recibís</p>
            <p className="font-display text-lg font-semibold text-ink sm:text-xl" data-id="element-154" data-mp="2fzj3p5pef3mf">10 archivos PDF</p>
          </div>
        </div>
      </div>
    </header>;
}